import React from "react";
import Link from "next/link";
import { useTranslations } from '../../../locales/useTranslations';
import { BiPhone, BiEnvelope, BiLogoLinkedin } from "react-icons/bi";

const WordpressBetreuungCTA = () => {
    const { t } = useTranslations();

    return (
        <>
            <div className="service-details pb-70">
                <div className="container">
                    <div className="service-details-content">

                        <div className="pt-35">
                            <h2>{t('wordpressSupport_cta_title')}</h2>
                            <p>
                                {t('wordpressSupport_cta_description')}
                            </p>
                        </div>

                        <div className="pt-35">
                            <h3>{t('wordpressSupport_cta_services_title')}</h3>
                            <p>
                                {t('wordpressSupport_cta_services_description')}
                            </p>
                        </div>

                        <div className="service-details pt-35">
                            <div className="service-details-info ">
                                <div className="large-info-box">
                                    <h4>{t('wordpressSupport_cta_box_title')}</h4>
                                    <span>{t('wordpressSupport_cta_box_description')}</span>
                                </div>

                                <div className="single-info-box">
                                    <h4>{t('wordpressSupport_cta_contact_title')}</h4>
                                    <ul className="social">
                                        <li>
                                            <a href="tel://+4943170577024" target="_blank">
                                                <BiPhone />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="mailto:info@simplify-data.de" target="_blank">
                                                <BiEnvelope />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.linkedin.com/company/simplify-data-ug/" target="_blank">
                                                <BiLogoLinkedin />
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                                <div className="single-info-box">
                                    <Link href="/kontakt/" className="default-btn">
                                        {t('wordpressSupport_cta_contact_button')}
                                    </Link>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default WordpressBetreuungCTA;
